export const COLOR_DEFAULTS: Record<string, string> = {
  basic: "#000000",
  foregroundPrimary: "#333333",
  foregroundSecondary: "#666666",
  foregroundTertiary: "#999999",
  backgroundPrimary: "#FFFFFF",
  backgroundSecondary: "#F5F5F5",
  backgroundTertiary: "#E0E0E0",
};
